import { useAction, useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, CloseIcon } from '@blade/ui-kit'
import { ConfirmDialog, EditIcon, Trash2Icon } from '@root/shared/ui-kit'

import type { Comment } from '@root/entities/comment'
import type { CommentsModel } from '@root/features/comment/atoms'

type CommentItemHeaderAuthorProps = {
  comment: Comment.Comment
  model: CommentsModel
}

export const CommentItemHeaderAuthor = ({
  comment,
  model,
}: CommentItemHeaderAuthorProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const deleteComment = useAction(model.deleteCommentAction)
  const [editCommentId, setEditCommentId] = useAtom(model.editCommentIdAtom)

  const handleDelete = () => {
    setOpen(false)
    deleteComment({
      pairAddress: comment.pairAddress,
      req: { commentId: comment.id },
    })
  }

  const handleEdit = () =>
    setEditCommentId(editCommentId === comment.id ? undefined : comment.id)

  const IconEdit = editCommentId === comment.id ? CloseIcon : EditIcon

  return (
    <>
      <ConfirmDialog
        open={open}
        onOpenChange={setOpen}
        title={t('comment.delete.confirmation.title')}
        description={t('comment.delete.confirmation.description')}
        describedBy={t('comment.delete.confirmation.title')}
        onConfirm={handleDelete}
        onCancel={() => setOpen(false)}
        intent="error"
      />
      <DeleteButton
        size="xxs"
        variant="ghost"
        iconRight={<Trash2Icon />}
        onClick={() => setOpen(true)}
      >
        {t('comment.message.delete')}
      </DeleteButton>
      <EditButton
        size="xxs"
        variant="ghost"
        iconRight={<IconEdit />}
        onClick={handleEdit}
      >
        {t(
          editCommentId === comment.id
            ? 'comment.message.editing'
            : 'comment.message.edit',
        )}
      </EditButton>
    </>
  )
}

const EditButton = styled(Button)`
  color: var(--text-9);

  &:hover {
    background: transparent;
  }

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  height: 20px;

  padding-inline: 2px;

  svg {
    width: 16px;
  }
`

const DeleteButton = styled(Button)`
  color: var(--text-9);

  &:hover {
    background: transparent;
  }

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  height: 20px;

  padding-inline: 2px;

  svg {
    width: 16px;
  }
`
